import { Box, makeStyles, useMediaQuery } from "@material-ui/core";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import MiniGameImage from "src/assets/images/minigame.png";

const useStyle = makeStyles(() => ({
  root: {
    cursor: "pointer",
    position: "fixed",
    bottom: 15,
    right: 15,
    zIndex: 10000,
    transition: "all 1s ease",
    animation: "$rotate 1.5s infinite",
    "&:hover": {
      animation: "none",
      transform: "translate(0px, -4px)",
      filter: "brightness(1.3) drop-shadow(0 0 5px yellow)",
    },
  },
  "@keyframes rotate": {
    "0%": {
      transform: "rotate(3deg)",
    },
    "10%": {
      transform: "rotate(-3deg)",
    },
    "20%": {
      transform: "rotate(3deg)",
    },
    "30%": {
      transform: "rotate(-3deg)",
    },
    "35%": {
      transform: "rotate(0deg)",
      filter: "none",
    },
    "70%": {
      filter: "brightness(1.3) drop-shadow(0 0 5px yellow)",
    },
    "100%": {
      transform: "rotate(0deg)",
      filter: "none",
    },
  },
}));

export default function MiniGameButton() {
  const cls = useStyle();
  const history = useHistory();
  const xsOnly = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  const show = useMemo(() => {
    const isBattle = history.location.pathname.startsWith("/battle-hand");
    const isDilution = history.location.pathname.startsWith("/dilution-staking");
    return !isBattle && !isDilution;
  }, [history.location]);

  return !show || xsOnly ? (
    <></>
  ) : (
    <Box className={cls.root} onClick={() => history.push("/battle-hand")}>
      <img src={MiniGameImage} style={{ width: 150, height: 61, objectFit: "cover" }} />
    </Box>
  );
}
